var React = require('react');

function MarsStrokeH (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M200.54 312.58a80.06 80.06 0 1 1 0-113.2 80.09 80.09 0 0 1 0 113.2z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M476.41 247.44l-56-55.93A12 12 0 0 0 399.9 200v24h-23.74v-20a12 12 0 0 0-12-12h-40a12 12 0 0 0-12 12v20h-27.69a144 144 0 1 0 0 64h27.63v20a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-20h23.93v23.91a12 12 0 0 0 20.52 8.51l55.95-55.93a12.12 12.12 0 0 0-.09-17.05zm-275.87 65.14a80.06 80.06 0 1 1 0-113.2 80.09 80.09 0 0 1 0 113.2z","className":"fa-primary","key":2})]);
}

MarsStrokeH.defaultProps = {"viewBox":"0 0 480 512","className":"icon"};

module.exports = MarsStrokeH;

MarsStrokeH.default = MarsStrokeH;
